type Props = {
  placeholder?: React.ReactElement;
  state?: "idle" | "loading" | "success" | "error";
  errorView?: React.ReactElement;
  children: React.ReactElement;
};

/**
 * A widget that displays the component's view based on the state of the component.
 * @param {React.ReactElement} placeholder - The placeholder view to be displayed when the state is loading.
 * @param {React.ReactElement} errorView - The error view to be displayed when the state is error.
 * @param {React.ReactElement} children - The component's view.
 * @param {string} state - The state of the component.
 */
const WidgetState = ({ state, placeholder, errorView, children }: Props) => {
  const renderContent = () => {
    switch (state) {
      case "idle":
      case "success":
        return children;
      case "loading":
        return placeholder;
      case "error":
        return errorView;
      default:
        return children;
    }
  };

  return <div>{renderContent()}</div>;
};

export default WidgetState;
